import { Box } from '@dtx-company/shared-components/src'
import { CardSliceContent } from '@app/code/src/types/prismic.types'
import { CreateFlowcodeForm } from '@app/code/src/components/Homepage/CreateFlowcodeForm'
import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import {
  FlowcodeTopSmallBannerResp,
  JumpMenu,
  PrismicAPIResp
} from '@app/code/src/components/Homepage/HomepageStaticContent/types'
import { HomepageBelowFoldExperimentData } from '@app/code/src/components/Homepage/HomepageStaticContent/variants/types'
import { HomepageTopBanner } from '@app/code/src/components/Homepage/HomepageTopBanner'
import { HowToSchema } from '@app/code/src/components/Homepage/HowToSchema'
import { Meta } from '../../../constants/meta'
import { PageContainer } from '../../layout'
import { ProUpsellBanner } from '@app/code/src/components/Homepage/ProUpsellBanner'
import { RootCodeState } from '@dtx-company/inter-app/src/redux/types'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { useIsMobileOrTablet } from '@app/code/src/hooks/useIsMobileOrTablet'
import { useOnce } from '@dtx-company/true-common/src/hooks/useOnce'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'
import { useRouter } from 'next/router'
import LongAndColorful from '@app/code/src/components/Homepage/HomepageStaticContent/variants/V2-LongAndColorful'
import React from 'react'

export interface FreeQrCodeGeneratorPageProps {
  homepageData: PrismicAPIResp[]
  bannerData: { [key: string]: CardSliceContent }
  homepageBelowFoldExperimentData: HomepageBelowFoldExperimentData
  injectedMeta?: Meta
  swrFallback?: Record<string, unknown>
}
//hosted on www so need aboslute url
const createFlowcodeAbsoluteUrl = FLOWCODE_ROOT + Routes.CREATE_FLOWCODE
export const FreeQrCodeGeneratorPage = (props: FreeQrCodeGeneratorPageProps): JSX.Element => {
  const { homepageData, bannerData, homepageBelowFoldExperimentData, injectedMeta } = props
  const { hideFooter } = useCodeSelector((state: RootCodeState) => {
    return state.settings
  })
  const showStaticContent = useCodeSelector(state => state.homePage.showStaticContent)

  const bannerSlice: FlowcodeTopSmallBannerResp | undefined = homepageData.find(
    slice => slice.slice_type === 'flowcode_top_small_banner'
  )
  const jumpMenu = homepageData.find(slice => slice.slice_type === 'jump_menu')
  const isMobileOrTablet = useIsMobileOrTablet()
  const router = useRouter()
  const { isAuthChecked, isAuthenticated } = useAuthState()
  //TODO: update to use Auth hook once it's available, ideally this check is done ServerSide
  //Only run this check once becuase a user will be authenticated after signing up
  useOnce(() => {
    if (!isAuthChecked) return false
    if (isAuthChecked && !isAuthenticated) return
    router.replace(createFlowcodeAbsoluteUrl)
  })

  useRedirectOnAuthChanges()

  return (
    <PageContainer
      disableSideNav
      injectedMeta={injectedMeta}
      page={Routes.FREE_QR_CODE_GENERATOR}
      disableFooter={hideFooter}
    >
      <Box display="block">
        {bannerSlice?.primary?.header && (
          <HomepageTopBanner
            header={bannerSlice?.primary?.header}
            backgroundColor={bannerSlice?.primary?.background_color}
            display={isMobileOrTablet ? 'none' : 'block'}
          />
        )}
        {jumpMenu && (
          <HomepageTopBanner
            jumpMenu={jumpMenu as JumpMenu}
            backgroundColor={bannerSlice?.primary?.background_color}
            display={isMobileOrTablet ? 'none' : 'block'}
          />
        )}

        <CreateFlowcodeForm data={homepageData} />
        <Box display={['none', 'none', 'none', 'block']}>
          <ProUpsellBanner data={bannerData.proUpsellBannerCard} sectionId={'pro-upsell-banner'} />
        </Box>

        {showStaticContent && <LongAndColorful data={homepageBelowFoldExperimentData.v2} />}
      </Box>
      <HowToSchema />
    </PageContainer>
  )
}
